import { render } from "./Home.vue?vue&type=template&id=5fa0080a&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=5fa0080a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5fa0080a"

export default script